import { WeeklyRepeatRule } from '../../../lib/shared/calendar.types'

const DAYS_OF_WEEK = [
  { value: 0, label: 'Sun' },
  { value: 1, label: 'Mon' },
  { value: 2, label: 'Tue' },
  { value: 3, label: 'Wed' },
  { value: 4, label: 'Thu' },
  { value: 5, label: 'Fri' },
  { value: 6, label: 'Sat' },
]

interface WeeklyRecurrenceProps {
  rule: WeeklyRepeatRule
  onChange: (rule: WeeklyRepeatRule) => void
}

export function WeeklyRecurrence({ rule, onChange }: WeeklyRecurrenceProps) {
  const toggleWeekDay = (dayValue: number) => {
    const newDays = rule.daysOfWeek.includes(dayValue)
      ? rule.daysOfWeek.filter((d) => d !== dayValue)
      : [...rule.daysOfWeek, dayValue].sort()

    onChange({
      ...rule,
      daysOfWeek: newDays,
    })
  }

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Days of Week
      </label>
      <div className="flex flex-wrap gap-2">
        {DAYS_OF_WEEK.map((day) => (
          <button
            key={day.value}
            type="button"
            onClick={() => toggleWeekDay(day.value)}
            className={`px-4 py-2 rounded-md text-sm font-medium transition-colors
              ${
                rule.daysOfWeek.includes(day.value)
                  ? 'bg-blue-600 text-white hover:bg-blue-700'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
          >
            {day.label}
          </button>
        ))}
      </div>
      {rule.daysOfWeek.length === 0 && (
        <p className="mt-2 text-sm text-red-600">
          Please select at least one day of the week
        </p>
      )}
    </div>
  )
}
